import { getQaSelector } from '../../../../utils/common'
import { MultipleViewTypeListActiveItemPreviewCloseButton } from '../../../MultipleViewTypeList'
import { IntegrationsConnectForm } from '../IntegrationsConnectForm'
import { IntegrationsDisconnectModal } from '../IntegrationsDisconnectModal'
import { IntegrationsOauthConnectModal } from '../IntegrationsOauthConnectModal'
import { QA_NAME_INTEGRATIONS_PANEL } from '../RentalPortalIntegrations.constants'
import { useIntegrationsConnectionActions } from '../RentalPortalIntegrations.hooks'

import { IntegrationsPanelActions } from './IntegrationsPanelActions'
import { IntegrationsPanelFacts } from './IntegrationsPanelFacts'
import { IntegrationsPanelHeader } from './IntegrationsPanelHeader'
import {
  getIsIntegrationsConnectFormOpen,
  getIsIntegrationsDisconnectAction,
  getIsIntegrationsOauthModalOpen,
} from './RentalPortalIntegrationsPanel.utils'

import * as styles from './RentalPortalIntegrationsPanel.module.css'

function RentalPortalIntegrationsPanel({
  CloseButton = MultipleViewTypeListActiveItemPreviewCloseButton,
  canConfigure,
  connection,
  onChanged,
  onClose,
}) {
  const {
    action,
    handleCloseAction,
    handleConfirmConnect,
    handleConfirmDisconnect,
    handleStartConnect,
    handleStartDisconnect,
    hasConnection,
    isConnected,
    isCredentialConnect,
    isSaving,
  } = useIntegrationsConnectionActions({ connection, onChanged })

  const commonModalProps = {
    isSaving,
    portal: connection.portal,
    onCancel: handleCloseAction,
  }

  return (
    <div
      {...getQaSelector({ value: QA_NAME_INTEGRATIONS_PANEL })}
      className={styles.RentalPortalIntegrationsPanel}
    >
      <IntegrationsPanelHeader
        CloseButton={CloseButton}
        connection={connection}
        onClose={onClose}
      />
      {getIsIntegrationsConnectFormOpen({ action, isCredentialConnect }) ? (
        <IntegrationsConnectForm
          isSaving={isSaving}
          onCancel={handleCloseAction}
          onSubmit={handleConfirmConnect}
        />
      ) : (
        <>
          <IntegrationsPanelFacts connection={connection} />
          <IntegrationsPanelActions
            canConfigure={canConfigure}
            connection={connection}
            hasConnection={hasConnection}
            isConnected={isConnected}
            onConnect={handleStartConnect}
            onDisconnect={handleStartDisconnect}
          />
        </>
      )}
      {getIsIntegrationsOauthModalOpen({ action, isCredentialConnect }) ? (
        <IntegrationsOauthConnectModal
          {...commonModalProps}
          onSubmit={handleConfirmConnect}
        />
      ) : null}
      {getIsIntegrationsDisconnectAction(action) ? (
        <IntegrationsDisconnectModal
          {...commonModalProps}
          onSubmit={handleConfirmDisconnect}
        />
      ) : null}
    </div>
  )
}

export default RentalPortalIntegrationsPanel
